!function (s, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e(require("dayjs")) : "function" == typeof define && define.amd ? define(["dayjs"], e) : s.dayjs_locale_lt = e(s.dayjs);
}(this, function (s) {
  "use strict";

  s = s && s.hasOwnProperty("default") ? s.default : s;

  var e = "sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio".split("_"),
      i = "sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis".split("_"),
      d = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
      a = function a(s, _a) {
    return d.test(_a) ? e[s.month()] : i[s.month()];
  };

  a.s = i, a.f = e;
  var M = {
    name: "lt",
    weekdays: "sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis".split("_"),
    weekdaysShort: "sek_pir_ant_tre_ket_pen_šeš".split("_"),
    weekdaysMin: "s_p_a_t_k_pn_š".split("_"),
    months: a,
    monthsShort: "sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),
    ordinal: function ordinal(s) {
      return s + ".";
    },
    weekStart: 1,
    relativeTime: {
      future: "už %s",
      past: "prieš %s",
      s: "kelias sekundes",
      m: "minutę",
      mm: "%d minutes",
      h: "valandą",
      hh: "%d valandas",
      d: "dieną",
      dd: "%d dienas",
      M: "menesį",
      MM: "%d mėnesius",
      y: "metus",
      yy: "%d metus"
    },
    format: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY-MM-DD",
      LL: "YYYY [m.] MMMM D [d.]",
      LLL: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
      LLLL: "YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",
      l: "YYYY-MM-DD",
      ll: "YYYY [m.] MMMM D [d.]",
      lll: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
      llll: "YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"
    },
    formats: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY-MM-DD",
      LL: "YYYY [m.] MMMM D [d.]",
      LLL: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
      LLLL: "YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",
      l: "YYYY-MM-DD",
      ll: "YYYY [m.] MMMM D [d.]",
      lll: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
      llll: "YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"
    }
  };
  return s.locale(M, null, !0), M;
});